<div class="vi-card mb-2">

  <!-- Source word -->
  <div class="vi-col vi-col-src">
    <div class="vi-lang-label">{{ langSrcName }}</div>
    <div class="vi-word-src">{{ word.name }}</div>
  </div>

  <div class="vi-divider">
    <i class="fa-solid fa-arrow-right"></i>
  </div>

  <!-- Target word -->
  <div class="vi-col vi-col-tgt" [class.vi-col-tgt-ja]="langTgtCode === 'ja'">
    <div class="vi-lang-label">{{ langTgtName }}</div>

    <!-- Standard languages -->
    <div *ngIf="langTgtCode !== 'ja'">
      <div class="vi-word-tgt" [class.vi-word-tgt-ar]="langTgtCode === 'ar'" [innerHTML]="word.translation"></div>
      <div class="vi-phonetic" *ngIf="displayPhonetic && word.phonetics">{{ word.phonetics }}</div>
    </div>

    <!-- Japanese -->
    <div *ngIf="langTgtCode === 'ja'" class="vi-ja-group">
      <div>
        <div class="vi-lang-label" translate>Kana</div>
        <div class="vi-word-tgt">{{ word.translation }}</div>
      </div>
      <div *ngIf="word.kanji">
        <div class="vi-lang-label" translate>Kanji</div>
        <div class="vi-word-tgt">{{ word.kanji }}</div>
      </div>
      <div *ngIf="displayPhonetic && word.phonetics">
        <div class="vi-lang-label" translate>Romaji</div>
        <div class="vi-phonetic vi-phonetic-inline">{{ word.phonetics }}</div>
      </div>
    </div>
  </div>

  <!-- Audio -->
  <div class="vi-audio">
    <button
      type="button"
      class="vi-play-btn"
      [class.vi-play-disabled]="!word.audio"
      [disabled]="!word.audio"
      (click)="word.audio && audioSrv.play(word.audio)"
      [title]="word.audio ? 'Écouter' : 'Audio indisponible'">
      <i class="fa-solid fa-play"></i>
    </button>
  </div>

</div>
